<template>
  <div class="card profile-card mb-0">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="profile-view">
            <div class="profile-img-wrap">
              <RadialProgress
                :diameter="140"
                innerStrokeColor="#FE0000"
                stroke-linecap="butt"
                start-color="#009F42"
                stop-color="#009F42"
                :completed-steps="profileCompleted"
                :total-steps="100"
              >
                <div class="profile-img">
                  <a href="javascript:;"
                    ><img
                      :src="
                        personalDetails.profile_picture != null
                          ? personalDetails.profile_picture
                          : 'https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg'
                      "
                      alt="User Image"
                  /></a>
                </div>
              </RadialProgress>
            </div>
            <div class="profile-basic">
              <div class="row">
                <div class="col-md-5">
                  <div class="profile-info-left">
                    <h3 class="user-name m-t-0 mb-0">
                      {{
                        personalDetails.first_name != null
                          ? personalDetails.first_name
                          : ""
                      }}
                      {{
                        personalDetails.last_name != null
                          ? personalDetails.last_name
                          : ""
                      }}
                    </h3>
                    <h6 class="text-muted">
                      {{ positionalInformation.department_name }}
                    </h6>
                    <small class="text-muted">{{
                      positionalInformation.designation_name
                    }}</small>
                    <div class="staff-id">
                      Employee ID : {{ positionalInformation.hcm_id }}
                    </div>
                    <h6 class="text-muted">
                      Duty Type: {{ positionalInformation.employee_duty_type_name || 'N/A' }}
                    </h6>
                    <h6 class="text-muted">
                      Employment Level: {{ employmentLevel.level || 'N/A' }}
                    </h6>
                    <!-- emp lvl -->
                    <h6 class="text-muted">
                      Employee Grade: {{ employmentLevel.level }} {{ (employmentLevel.level && employmentGrade.grade) ? '-' : '' }}
                      {{ employmentGrade.grade }}
                    </h6>
                    <!-- <div class="doj text-muted">
                      <span style="color: #009f42">●</span> Active
                    </div> -->
                  </div>
                </div>
                <div class="col-md-7">
                  <ul class="personal-info">
                    <li>
                      <div class="title">Pseudo:</div>
                      <div class="text">
                        {{
                          positionalInformation.pseudo_name != null
                            ? positionalInformation.pseudo_name
                            : "N/A"
                        }}
                      </div>
                    </li>
                    <li>
                      <div class="title">Business Email:</div>
                      <div class="text text-email">
                        {{ positionalInformation.business_email }}
                      </div>
                    </li>
                    <li>
                      <div class="title">Birthday:</div>
                      <div class="text">{{ personalDetails.dob }}</div>
                    </li>
                    <li>
                      <div class="title">Section:</div>
                      <div class="text">
                        {{ positionalInformation.section_name }}
                      </div>
                    </li>
                    <li>
                      <div class="title">Date of Joining:</div>
                      <div class="text">
                        {{ positionalInformation.joining_date }}
                      </div>
                    </li>
                    <li>
                      <div class="title">Status:</div>
                      <div class="text">
                        {{ positionalInformation.status_name }}
                      </div>
                    </li>
                    <li>
                      <div class="title">Reporting Authority:</div>
                      <div class="text">
                        {{
                          positionalInformation.reporting_authority_name != null
                            ? positionalInformation.reporting_authority_name
                            : "N/A"
                        }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgress from "vue3-radial-progress";
import ProfilePercentageService from "@/services/ProfilePercentageService";

export default {
  components: {
    RadialProgress,
  },

  data() {
    return {
      personalDetails: {},
      positionalInformation: {},
      employmentLevel: {},
      employmentGrade: {},
      profileCompleted: 0,
    };
  },
  props: {
    userProfile: {
      type: Object,
      default: {},
    },
  },
  async created() {
    try {
      const response = await ProfilePercentageService.fetchPercentage();
      this.profileCompleted = Math.ceil(response.data.profile_percentage);
    } catch (error) {
      console.log("error fetching", error);
    }
  },

  watch: {
    userProfile: {
      handler() {
        this.personalDetails =
          this.userProfile && this.userProfile.employee_personal_information
            ? this.userProfile.employee_personal_information
            : {};
        this.positionalInformation =
          this.userProfile && this.userProfile.employee_positional_information
            ? this.userProfile.employee_positional_information
            : {};
        this.employmentLevel =
          this.userProfile && this.userProfile.employment_level
            ? this.userProfile.employment_level
            : {};
        this.employmentGrade =
          this.userProfile && this.userProfile.employment_grade
            ? this.userProfile.employment_grade
            : {};
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.profile-card {
  background: #fff;
}
</style>
